import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CompanyProfileService {
  private mainURL = 'api/';

  constructor(private http: HttpClient) {}

  getCompanyProfile() {
    return this.http.get(`${environment.apiUrl}${this.mainURL}company/profile`);
  }

  updateCompanyProfile(payload: FormData) {
    return this.http.put(
      `${environment.apiUrl}${this.mainURL}company/profile`,
      payload,
    );
  }

  getDocument(path: string): Observable<Blob> {
    // If path is already a full URL use it as-is, otherwise prepend the base
    const url = path.startsWith('http') ? path : `${environment.apiUrl}${path}`;

    // Read the token from wherever your app stores it
    const token =
      localStorage.getItem('accessToken') ??
      sessionStorage.getItem('accessToken') ??
      '';

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get(url, { responseType: 'blob', headers });
  }
}
